module.exports = __webpack_public_path__ + "static/media/egg_headkv.dd80a210.png";